export default __webpack_public_path__ + "static/media/novendors.dd833b0a.png";